import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Box } from '@mui/material';
import TemplateMessageEditor from './Components/TemplateMessageEditor';
import EditorButton from '../../Components/Inputs/BigButton';
import { EDITORS } from './Utils/constants';
import MediaDialog from './Components/Media';

/**
 * Editor section to edit Templates, Media and LandingPages for Massive Sends:
 *
 * @param {Object} props - Component's props.
 * @param {Boolean} props.heightQuery - Boolean. Media query for height.
 *
 * @returns {React.JSX.Element} React fragments containing a MuiBox and a MuiDialog.
 */

const Editor = function Editor({ heightQuery = true }) {
  const intl = useIntl();

  const [editorDialog, setEditorDialog] = useState(null);
  const [mediaDialog, setMediaDialog] = useState(false);

  const handleOpenEditor = (editorPage) => () => {
    setEditorDialog(editorPage);
  };
  const handleCloseEditor = () => {
    setEditorDialog(null);
  };

  const handleOpenMedia = () => {
    setMediaDialog(true);
  };
  const handleCloseMedia = () => {
    setMediaDialog(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "54px",
          flexWrap: "wrap",
          p: heightQuery ? '12%' : '4%'
        }}>
        <EditorButton
          title={intl.messages.TEMPLATES}
          subtitle={`${intl.messages.SMS} ${intl.messages.AND} ${intl.messages.EMAIL}`}
          onClick={handleOpenEditor('TEMPLATES')}
          bgcolor="#e2e5ff"
          icon={<EDITORS.TEMPLATES sx={{ color: '#274db0', fontSize: 43 }} />}
        />
        <EditorButton
          title={intl.messages.MEDIA}
          subtitle={intl.messages.GALLERY}
          onClick={handleOpenMedia}
          bgcolor="#fbe2ff"
          icon={<EDITORS.MEDIA sx={{ color: '#9c27b0', fontSize: 43 }} />}
        />
        <EditorButton
          title={intl.messages.LANDING_PAGES}
          subtitle={intl.messages.SMS}
          onClick={handleOpenEditor('LANDING_PAGES')}
          bgcolor="#dae9d4"
          icon={<EDITORS.LANDING_PAGES color="#2E7D32" fontSize={43} />}
        />
      </Box>
      <TemplateMessageEditor open={editorDialog} onClose={handleCloseEditor} />
      <MediaDialog open={mediaDialog} onClose={handleCloseMedia} />
    </>
  );
};

Editor.propTypes = {
  heightQuery: PropTypes.bool,
};

export default Editor;
